import { Injectable } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { UrlValidator } from "@atenea-cms";
import { Reseller } from "./reseller.model";
import { Country } from "../../countries/shared";

@Injectable()
export class ResellerFormService {
  constructor(private fb: FormBuilder) {}

  getForm(reseller: Reseller = new Reseller()): FormGroup {
    return this.fb.group({
      _id: [reseller._id],
      name: [reseller.name, Validators.required],
      image: [reseller.image],
      url: [reseller.url, UrlValidator],
      type: [reseller.type],
      country: [reseller.country ? reseller.country._id : null],
      position: [reseller.position],
      active: [reseller.active],
    });
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/shared/reseller-form.service.ts